var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGrasSavoye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2_00000010300460977284384180000007027423945064954249_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74.8 38",
    style: {
      enableBackground: "new 0 0 74.8 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,37.1c-0.3,0.1-0.9,0.2-1.7,0.2c-2.4,0-3.5-1.5-3.5-3.3c0-2.1,1.4-3.3,3.5-3.3c0.6,0,1.4,0.1,2,0.4 c0.1,0,0.3,0.1,0.4,0.1c0,0,0.2-0.1,0.2-0.2l0-0.6c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-1.1-0.2-2.1-0.2C1.1,30,0,32.5,0,34.2 c0,0.6,0.1,1.5,0.8,2.3c0.7,0.8,1.7,1.3,3.6,1.3c0.8,0,2-0.1,2.9-0.3V34h-1L6.3,37.1L6.3,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,36.7C14,36.1,12,34.3,12,34.3s0.5,0.1,0.9,0s1.7-0.7,1.7-2.1c0-0.5-0.2-1.1-0.6-1.5 c-0.5-0.5-1.2-0.6-2.4-0.6c-0.6,0-1.9,0-2.1,0v7.6h1v-7c0.4,0,0.9,0,1.1,0c0.8,0,2,0,2,1.5s-1.3,1.6-2.3,1.6l-0.5,0l3.4,3.8h1.5 C15.6,37.6,15.1,37.3,14.5,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,30.2l-3.7,7.6h1l1.1-2.5h3.4l0.9,2.5h1.1l-3-7.6H19.5L19.5,30.2z M18.1,34.7l1.6-3.5l1.4,3.5 C21,34.7,18.1,34.7,18.1,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.8,33.5C25.5,33,25,32.7,25,31.9c0-1.1,1.1-1.3,1.7-1.3c0.6,0,1.2,0.2,1.6,0.4c0.1,0,0.2,0.1,0.2,0.1 c0,0,0.2-0.1,0.2-0.1v0l-0.1-0.7c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.7-0.2-1.5-0.2C25,30,24,30.9,24,32.1c0,1.2,1,1.6,2.3,2.2 c0.9,0.4,1.7,0.7,1.7,1.6c0,1-1,1.3-1.8,1.3s-1.6-0.2-2.1-0.5c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.2,0.1-0.2,0.1c0,0,0,0,0,0.1l0.1,0.7 c0,0.1,0.2,0.2,0.4,0.2c0.5,0.1,1.3,0.2,1.9,0.2c2.1,0,3-1.2,3-2.2C29,34.4,27.8,33.8,26.8,33.5L26.8,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.1,33.5c-1.3-0.5-1.8-0.8-1.8-1.5c0-1.1,1.1-1.3,1.7-1.3c0.6,0,1.2,0.2,1.6,0.4c0.1,0,0.2,0.1,0.2,0.1 c0,0,0.2-0.1,0.2-0.1v0l-0.1-0.7c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.7-0.2-1.5-0.2c-1.9,0-2.8,0.9-2.8,2.1c0,1.2,1,1.6,2.3,2.2 c0.9,0.4,1.7,0.7,1.7,1.6c0,1-1,1.3-1.8,1.3s-1.6-0.2-2.1-0.5c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.2,0.1-0.2,0.1c0,0,0,0,0,0.1l0.1,0.7 c0,0.1,0.2,0.2,0.3,0.2c0.5,0.1,1.3,0.2,1.9,0.2c2.1,0,3-1.2,3-2.2C38.3,34.4,37.1,33.8,36.1,33.5L36.1,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,30.2L39,37.8h1l1.1-2.5h3.4l0.9,2.5h1.1l-3-7.6H42.6L42.6,30.2z M41.3,34.7l1.6-3.5l1.4,3.5 C44.2,34.7,41.3,34.7,41.3,34.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.8,36.5 47.3,30.2 46.2,30.2 49.3,37.8 49.9,37.8 53.5,30.2 52.6,30.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,30c-3.1,0-4.4,2.3-4.4,4c0,2,1.6,4,4.1,4c2.7,0,4.3-2,4.3-4.1S60.7,30,58.2,30z M58.7,37.3 c-1.7,0.3-3.2-1.1-3.6-3c-0.2-1.1,0-2.2,0.6-2.9c0.5-0.6,1.2-0.8,1.7-0.9c1.8-0.3,3.1,1.5,3.3,3C61.1,35.2,60.4,37,58.7,37.3 L58.7,37.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65.7,33.8 63.4,30.2 62.3,30.2 65,34.5 65,37.8 66,37.8 66,34.4 69.1,30.2 68,30.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.7,37.1 70.7,34.1 74.3,34.1 74.3,33.4 70.7,33.4 70.7,30.8 74.8,30.8 74.8,30.2 69.7,30.2  69.7,37.8 74.8,37.8 74.8,37.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,26.5c0.9-0.5,1.5-0.8,1.7-1.5c0.2-0.6-0.6-1.1-1.2-0.6c-0.6,0.4-1,1.2-1.5,2 C16.4,26.8,16.8,27,17.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,18l1.2-1.1c0,0-9.9-7.4-20.6-6.1c0.2-0.6,0.2-1,0.2-1s1,0.1,2.4-0.3c1.4-0.4,2.9-1.2,3.5-1.4 c0.6-0.2,0.5-0.7,0.6-1c0.1-0.3,0.1-0.7-0.3-0.8c-0.3-0.1-0.7,0-2.4-0.1c-1.7-0.1-3.4-0.8-3.4-0.8s0,0,0-0.1 c-0.1-0.4-0.8-1.8-2.1-1.8c-2.1,0-2.1,2.3-2.7,4.1s-4.2,5.5-4.2,5.5c1.3-0.2,2,0,2.4,0.4c-0.4,0.8-2.5,4.3-5.5,6.7 c-3.5,2.7-5.7,3-7.5,3.6l0.2,1.1c0,0,4.8,0.6,9.2-1.9c4.4-2.5,6.4-4,9.5-7.6C38.5,15.5,49.2,13.8,57.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,2.2c0,0.1,0,0.3,0,0.3s0.5,0.1,0.6,0.2c0.2,0.1,0,0.2,0.1,0.3c0.1,0.1,0.3,0.3,0.6,0.5s0.6,0.2,0.9,0 s0.4-0.6,0.6-0.9c0.2-0.3,0.1-0.9-0.1-1.3c-0.2-0.4-0.2-0.9-0.2-0.9s-0.1,0-0.2-0.1c-0.2-0.1,0,0-0.1-0.2S38.7,0,38.3,0.1 c-0.5,0.1-0.8,0.3-1.2,0.7s-0.7,0.3-0.7,0.3c0,0.2,0.4,1,0.4,1S37,2.2,37,2.2L37,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,7.5c0.3-0.1,1.2-0.4,1.2-0.7s-0.7-0.4-1.4-0.4c-0.3,0-1,0-1,0.7S46.6,7.6,47,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.5,17c-0.3,0-0.4,0.8-0.5,0.8s-0.1,0.2,0,0.4c0.1,0.1,0.5,0.6,1.2,0.7s1.6,0,1.8-0.1s0.3-0.2-0.4-0.9 C61,17.3,59.5,17,59.5,17z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrasSavoye);
export default __webpack_public_path__ + "static/media/logo_gras_savoye.54e16da12ecd63c22dbfa3bb66fb73b1.svg";
export { ForwardRef as ReactComponent };